
import { CaseState } from 'app/area/case/types-store';
import { tableName } from 'app/area/case/case-data-model';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';

export const sectionLinks = (
  state: CaseState | CaseListingInstanceState,
  uiEngineProps: ConnectedComponentProps
) => {
  const caseTypeId = uiEngineProps.resolveContext.applicationId;
  const uiDefinition = (state as CaseState).uiDefinition || 
    ((state as CaseListingInstanceState).uiDefinitions ? 
      (state as CaseListingInstanceState).uiDefinitions.some(uiDef=>uiDef.caseTypeId === caseTypeId) : 
      undefined
    );
  
  if(!uiDefinition){
    return undefined;
  }
  
  const valueOf = (childDomain:string) => {
    const val = Number(uiEngineProps.componentDescriptor.properties[`linkDomain${childDomain}`]);    
    return Number.isFinite(val) ? Number(val) : undefined;
  };

  const links = [    
    {
      id: tableName.action,
      section: valueOf('Actions')
    },
    {
      id: tableName.consequences,
      section: valueOf('Consequences')
    },
    {
      id: tableName.assessment,
      section: valueOf('Assessments')
    },
    {
      id: tableName.attachmentType,
      section: valueOf('Attachments')
    },
    {
      id: tableName.causes,
      section: valueOf('Causes')
    },
    {
      id: tableName.checklist,
      section: valueOf('Checklists')
    },
    {
      id: tableName.comment,
      section: valueOf('Comments')
    },
    {
      id: tableName.connectedCases,
      section: valueOf('ConnectedCases')
    },
    {
      id: tableName.involvedDrug,
      section: valueOf('InvolvedDrugs')
    },
    {
      id: tableName.involvedPerson,
      section: valueOf('InvolvedPersons')
    },
    {
      id: tableName.lossPotentialEvaluation,
      section: valueOf('RiskArea')
    },
    {
      id: tableName.lossPotentialResidualEvaluation,
      section: valueOf('RiskAreaRest')
    },
    {
      id: 'BarrierEval',
      section: valueOf('IntegrityStatusBarrierEval')
    },
    {
      id: 'IntegrityStatus',
      section: valueOf('IntegrityStatus')
    },
    {
      id: tableName.green,
      section: valueOf('EnvironmentalValues')
    }
  ];

  return {
    links
  };
};
